import React from 'react'
import HomeNavBar2 from '../Components/HomeNavBar/HomeNavBar2';
import Footer from '../Components/Footer/Footer';
import Courses from '../Components/Courses/Courses';

const CoursesPage = () => {
  return (
    <div>
      <HomeNavBar2 />
      <Courses/>
      <Footer/>
    </div>
  );
}

export default CoursesPage